var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSurveyIndependent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 107,
    viewBox: "0 0 127 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.489 0a5.08 5.08 0 0 1 5.079 5.08v44.867a5.08 5.08 0 0 1-5.079 5.08h-5.503v14.39c0 1.694-.423 6.773-4.656 2.117-3.009-3.31-9.808-11.547-13.858-16.508h-47.94a5.08 5.08 0 0 1-5.08-5.08V5.08A5.08 5.08 0 0 1 49.532 0h71.957z",
    fill: "#5959EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.432 16a5 5 0 0 1 5-5h46a5 5 0 0 1 0 10h-46a5 5 0 0 1-5-5z",
    fill: "#1AD99E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.432 35a5 5 0 0 1 5-5h46a5 5 0 0 1 0 10h-46a5 5 0 0 1-5-5z",
    fill: "#BF3DC2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.897 30.164a5.08 5.08 0 0 0-5.08 5.08V80.11a5.08 5.08 0 0 0 5.08 5.079H14.4V99.58c0 1.693.423 6.773 4.656 2.117 3.01-3.31 9.808-11.547 13.859-16.508h47.94a5.08 5.08 0 0 0 5.079-5.08V35.244a5.08 5.08 0 0 0-5.08-5.08H8.897z",
    fill: "#F8D856"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.897 33.55c-.935 0-1.693.758-1.693 1.693V80.11c0 .936.758 1.694 1.693 1.694h8.889v16.225c3.307-3.786 8.933-10.605 12.506-14.98l1.016-1.245h49.546c.935 0 1.694-.758 1.694-1.694V35.244c0-.935-.759-1.693-1.694-1.693H8.897zM.432 35.243a8.466 8.466 0 0 1 8.465-8.465h71.957a8.466 8.466 0 0 1 8.466 8.465V80.11a8.466 8.466 0 0 1-8.466 8.466H34.52c-4.086 4.99-10.122 12.279-12.959 15.4-1.166 1.282-2.564 2.487-4.23 2.886-.938.225-1.967.192-2.952-.233a4.782 4.782 0 0 1-2.005-1.656c-.767-1.087-1.053-2.352-1.183-3.141a14.225 14.225 0 0 1-.177-2.25V88.575H8.897a8.466 8.466 0 0 1-8.465-8.465V35.242z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.061 58.1a5.08 5.08 0 1 1-10.158 0 5.08 5.08 0 0 1 10.158 0zM49.532 58.1a5.08 5.08 0 1 1-10.159 0 5.08 5.08 0 0 1 10.159 0zM69.003 58.1a5.08 5.08 0 1 1-10.159 0 5.08 5.08 0 0 1 10.159 0z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyIndependent);
export default __webpack_public_path__ + "static/media/survey-independent.9ef5420a2bf4cd721f2010b2ff413f00.svg";
export { ForwardRef as ReactComponent };